import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from '@assets/locales/en/translations.json';
import nl from '@assets/locales/nl/translations.json';
import fr from '@assets/locales/fr/translations.json';
import de from '@assets/locales/de/translations.json';

const resources = {
  en: {
    translation: en
  },
  nl: {
    translation: nl
  },
  fr: {
    translation: fr
  },
  de: {
    translation: de
  }
};

const isDev = import.meta.env.DEV;

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    lng: localStorage.getItem('i18nextLng') ?? 'en',
    fallbackLng: ['en'],
    interpolation: {
      escapeValue: false
    },
    saveMissing: isDev,
    missingKeyHandler: isDev
      ? (_lngs, _ns, key) => {
          // eslint-disable-next-line no-console
          console.warn(`[i18n] Missing key: "${key}"`);
        }
      : undefined
  });

// Keep <html lang> in sync with the active i18n language for WCAG 3.1.1.
const syncHtmlLang = (lng: string) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng.split('-')[0] || 'en';
  }
};
syncHtmlLang(i18n.language);
i18n.on('languageChanged', syncHtmlLang);

export default i18n;
